exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".input-like {\n  border: 1px solid #999;\n  color: #000000;\n  border-radius: 0.375em;\n  background-color: #ffffff; }\n  .input-like:hover, .input-like:focus {\n    outline: none;\n    border-color: #27C7FC; }\n  .input-like:focus {\n    background-color: #ffffff; }\n  .input-like:disabled {\n    background-color: #999;\n    cursor: default; }\n\n*, *:before, *:after {\n  -webkit-transition: all 0.35s ease-in-out;\n  -moz-transition: all 0.35s ease-in-out;\n  -ms-transition: all 0.35s ease-in-out;\n  -o-transition: all 0.35s ease-in-out;\n  transition: all 0.35s ease-in-out; }\n\np {\n  margin: 0 0 1em 0; }\n\n* + p {\n  margin-top: 1em; }\n\nh1 + p, h2 + p, h3 + p, h4 + p, h5 + p, h6 + p {\n  margin-top: 0; }\n\nbody {\n  background: #005F7F; }\n  body > .unloaded-message {\n    color: #FFC60E;\n    display: block;\n    font-weight: bold;\n    font-size: 3em;\n    margin: 1em auto;\n    text-align: center; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/styles/style.scss
// module id = 191
// module chunks = 0